export default "__VITE_ASSET__Dhrwp10d__"